import { getStudentListDB, getTeacherIDbyLink, updateAnswer } from "../firebase/firebaseController";

export const SELECT_STUDENT= "SELECT_STUDENT";
export const SELECT_STUDENT_SUCCESS ="SELECT_STUDENT_SUCCESS";

export const GET_STUDENT_LIST = "GET_STUDENT_LIST";
export const GET_STUDENT_LIST_SUCCESS ="GET_STUDENT_LIST_SUCCESS";

export const GET_TEACHER_ID = "GET_TEACHER_ID";
export const GET_TEACHER_ID_SUCCESS = "GET_TEACHER_ID_SUCCESS";
export const GET_TEACHER_ID_ERROR = "GET_TEACHER_ID_ERROR";

export const getTeacherID =()=>({
    type: GET_TEACHER_ID
})

export const getTeacherIDError =(error)=>({
    type: GET_TEACHER_ID_ERROR,
    payload: error
})

export const getTeacherIDSuccess = (teacherID)=>({
    type: GET_TEACHER_ID_SUCCESS,
    payload: teacherID
})

export const getID = (roomID)=>{
    return async function(dispatch, getState, args){
        try{
            dispatch(getTeacherID());
            let teacherID = await getTeacherIDbyLink(roomID);
            if(!teacherID) dispatch(getTeacherIDError("Invalid Link!"));
            else dispatch(getTeacherIDSuccess(teacherID));
        }
        catch(e){
            console.log(e)
            dispatch(getTeacherIDError(e.message));
        }
    }
}


export const getStudentList = ()=>({
    type:GET_STUDENT_LIST
})

export const getStudentListSuccess = (studentList) =>({
    type:GET_STUDENT_LIST_SUCCESS,
    payload: studentList
})

export const getStudentSelectList = (teacherID)=>{
    return async function (dispatch,getState,args){
        try{
            dispatch(getStudentList());
            let studentList = await getStudentListDB(teacherID);
            console.log("student list",studentList);
            dispatch(getStudentListSuccess(studentList))
        }
        catch(e){
            console.log(e);
        }
    }
}

export const selectStudent = ()=>({
    type:SELECT_STUDENT
})

export const selectStudentSuccess = (student)=>({
    type:SELECT_STUDENT_SUCCESS,
    payload: student
})

export const submitSelectStudent=(student,evt=null)=>{
    return async function (dispatch,getState,args){
        try{
            dispatch(selectStudent());
            await new Promise(resolve => setTimeout(resolve, 2000));
            dispatch(selectStudentSuccess(student))
            if(evt){
                evt();
            }
        } 
        catch(e){
            console.log(e.message);
        }
    }
}


//Sync
export const SYNC_DATA = "SYNC_DATA";
export const SYNC_DATA_SUCCESS = "SYNC_DATA_SUCCESS";

export const syncData = ()=>({
    type: SYNC_DATA
})

export const syncDataSuccess = ()=>({
    type: SYNC_DATA_SUCCESS
})

export const startSync =(teacherID,studentID,answer)=>{
    return async function(dispatch,getState,args){
        dispatch(syncData());
        await new Promise(resolve => setTimeout(resolve, 500));
        updateAnswer(teacherID,studentID,answer);
        dispatch(syncDataSuccess());
    }
}